var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPhoneIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 22,
    viewBox: "0 0 16 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.7493 22H5.24935C2.7221 22 0.666016 19.9439 0.666016 17.4167V4.58333C0.666016 2.05608 2.7221 0 5.24935 0H10.7493C13.2766 0 15.3327 2.05608 15.3327 4.58333V17.4167C15.3327 19.9439 13.2766 22 10.7493 22ZM5.24935 1.83333C3.73318 1.83333 2.49935 3.06717 2.49935 4.58333V17.4167C2.49935 18.9328 3.73318 20.1667 5.24935 20.1667H10.7493C12.2655 20.1667 13.4993 18.9328 13.4993 17.4167V4.58333C13.4993 3.06717 12.2655 1.83333 10.7493 1.83333H5.24935ZM9.83268 17.4167C9.83268 16.9107 9.42202 16.5 8.91602 16.5H7.08268C6.57668 16.5 6.16602 16.9107 6.16602 17.4167C6.16602 17.9227 6.57668 18.3333 7.08268 18.3333H8.91602C9.42202 18.3333 9.83268 17.9227 9.83268 17.4167Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhoneIcon);
export default __webpack_public_path__ + "static/media/phone_icon.1960e2655d02012128670ecfb2f8c69d.svg";
export { ForwardRef as ReactComponent };